import { dailyRunRateActionTypes } from '@Actions/inventory/dailyRunRateActions';

const DailyRunRateReducers = (state = {}, action) => {
  switch (action.type) {
    case dailyRunRateActionTypes.GET_DAILY_RUN_RATES.LOADING: {
      const { getDailyRunRatesLoading } = action;
      return {
        ...state,
        getDailyRunRatesLoading,
      };
    }
    case dailyRunRateActionTypes.GET_DAILY_RUN_RATES.SUCCESS: {
      const { dailyRunRates } = action;
      return {
        ...state,
        dailyRunRates,
      };
    }
    case dailyRunRateActionTypes.GET_DAILY_RUN_RATE_BY_ID.LOADING: {
      const { getDailyRunRateByIdLoading } = action;
      return {
        ...state,
        getDailyRunRateByIdLoading,
      };
    }
    case dailyRunRateActionTypes.GET_DAILY_RUN_RATE_BY_ID.SUCCESS: {
      const { selectedDailyRunRate } = action;
      return {
        ...state,
        selectedDailyRunRate,
      };
    }
    case dailyRunRateActionTypes.CREATE_DAILY_RUN_RATE.LOADING: {
      const { createDailyRunRateLoading } = action;
      return {
        ...state,
        createDailyRunRateLoading,
      };
    }
    case dailyRunRateActionTypes.UPDATE_DAILY_RUN_RATE.LOADING: {
      const { updateDailyRunRateLoading } = action;
      return {
        ...state,
        updateDailyRunRateLoading,
      };
    }
    case dailyRunRateActionTypes.DELETE_DAILY_RUN_RATE.LOADING: {
      const { deleteDailyRunRateLoading } = action;
      return {
        ...state,
        deleteDailyRunRateLoading,
      };
    }
    case dailyRunRateActionTypes.PIN_DAILY_RUN_RATE.LOADING: {
      const { pinDailyRunRateLoading } = action;
      return {
        ...state,
        pinDailyRunRateLoading,
      };
    }

    default: {
      return state;
    }
  }
};

export default DailyRunRateReducers;